import { UserServiceAccount } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useQuery } from '@tanstack/react-query';

export const GET_SERVICE_ACCOUNT_QUERY_KEY = 'users.getServiceAccount';

export const useGetServiceAccount = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [GET_SERVICE_ACCOUNT_QUERY_KEY],
    queryFn: api.users.listUserServiceAccounts,
    select: (data): UserServiceAccount | undefined => data.data.serviceAccounts,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
